import { DETACHED_LOCAL_STORAGE_KEY } from '../components/playground/DetachedPreview';

export const handleDetachWindow = (
    contentRef: React.RefObject<HTMLDivElement>,
    playgroundRef: React.RefObject<HTMLDivElement>
) => {
    if (!contentRef.current || !playgroundRef.current) {
        return;
    }

    // Store the component temporary  in localStorage to be able to render the content later on
    localStorage.setItem(DETACHED_LOCAL_STORAGE_KEY, contentRef.current?.innerHTML || '');

    // Open a new tab
    window.open('#/detached', '_blank');
};
